import Chance from '../utils/Chance'
import { uid } from '../utils/Common'
import Point, { pt } from '../utils/Point'
import { Direction } from '../utils/SwipeHelper'
import Card from './Card'
import Monster from './cards/Monster'
import Player from './cards/Player'
import Spell from './cards/Spell'
import Deck from './Deck'
import GameBoard from './GameBoard'

export default class Hero {
  id = uid()
  name = ''
  card: Player
  gold = 0

  spells: Deck
  selectedSpell?: Card
  curses: Card[] = []

  spellboundMonsters = new Map<Monster, Spell>()

  constructor(public board?: GameBoard) {
    this.card = new Player(20)
    this.spells = new Deck(this.board)

    for (let i = 0; i < 2; i++) {
      this.spells.add(new Spell())
    }
  }

  addSpell(card: Card) {
    if (this.spells.size >= 4) {
      this.spells.cards.pop()?.moveTo()
    }
    card.moveTo(this.spells, this.board)
  }

  setBoard(board: GameBoard) {
    this.board = this.spells.board = board
  }

  heal(value: number) {
    this.card.value += value
  }

  move(direction: Direction) {
    this.card.move(direction)

    this.spellboundMonsters.forEach((spell, monster) => {
      monster.move(direction)
    })

    console.clear()
    let log = ''
    for (let i = 0; i < this.board!.height; i++) {
      for (let j = 0; j < this.board!.width; j++) {
        log += `${this.board!.deckAt(j, i)?.size}\t`
      }
      log += '\n'
    }
    console.log(log)
  }

  takeDamage(value: number) {
    this.card.value -= value

    if (this.card.value <= 0) {
      this.card.value = 0
      alert('You lose!')
      setTimeout(() => {
        window.location.hash = '#'
      }, 3000)
    }
  }

  increaseGold(delta: number) {
    this.gold += delta
  }

  consumeSelectedSpell() {
    this.spells.remove(this.selectedSpell!)
    delete this.selectedSpell
  }
}
